/*
 * @Author: jingyu.yang 
 * @Date: 2021-12-17 09:51:37 
 * @Last Modified by: jingyu.yang
 * @Last Modified time: 2022-01-12 10:22:30
 */
import { getJson, post,put } from '.';

/**
 * 上传任务
 * @param {*} p 
 * @returns 
 */
 export const task = p => post(`${config.cppm}monitor/v2/webcast/resource/preUpload`, p);

/**
 * @function list
 * @desc 资源列表
 * @param {number} type 资源类型：0=文档 1=插播 2=暖场 3=伪直播
 * @returns 
 */
export const resourceList = (type) => getJson(`${config.cppm}monitor/v2/webcast/resource/${type}`);

/**
 * @function publish
 * @desc 发布资源
 * @param {number} resource_id 资源id
 * @returns 
 */
export const publish = (resource_id) => post(`${config.cppm}monitor/v2/webcast/resource/publish/${resource_id}`)

/**
 * @function unPublish
 * @desc 取消发布资源
 * @param {number} resource_id 资源id
 * @returns 
 */
export const unPublish = (resource_id) => post(`${config.cppm}monitor/v2/webcast/resource/cancel_publish/${resource_id}`)

/**
 * @function resourceBind
 * @desc 关联资源
 * @param {number} data.bindType 绑定类型: 1-仅绑定到场次, 2-同时绑定到场次和直播间
 * @param {number} data.resourceType 	资源类型：0=文档 1=插播 2=暖场 3=伪直播
 * @param {string} data.resourceId 	资源id
 * @returns 
 */
export const resourceBind = (data) => post(`${config.cppm}monitor/v2/webcast/resource/bind`, data)

/**
 * @function resourceUnBind
 * @desc 解除绑定关联资源
 * @param {string} resource_id 	资源id
 * @returns 
 */
export const resourceUnBind = (resource_id) => getJson(`${config.cppm}monitor/v2/webcast/resource/cancel_bind/${resource_id}`, {})

/**
 * @function resourceDeleteBind
 * @desc 解除绑定关联资源(删除场次内和关联到直播间的)
 * @param {string} resource_id 	资源id
 * @returns 
 */
export const resourceDeleteBind = (resource_id) => getJson(`${config.cppm}monitor/v2/webcast/resource/delete_bind/${resource_id}`, {})

/**
 * @function resourcePlay
 * @desc 开始播放插播件
 * @param {string} cloudRecordId 资源id
 * @returns 
 */
export const resourcePlay = (cloudRecordId) => getJson(`${config.cppm}monitor/v2/webcast/resource/play/${cloudRecordId}`, {})

/**
 * @function resourceEnd
 * @desc 停止播放插播件
 * @returns 
 */
export const resourceEnd = () => getJson(`${config.cppm}monitor/v2/webcast/resource/stop`, {})

/**
 * @function resourceSeek
 * @desc 拖动插播件进度条
 * @param {string} seek_time ms
 * @returns 
 */
export const resourceSeek = (seek_time) => getJson(`${config.cppm}monitor/v2/webcast/resource/seek/${seek_time}`, {})

/**
 * @function setAutoBind
 * @desc 设置自动关联
 * @param {boolean} status     自动关联状态  0:开启;1:关闭
 * @param {string}  webcastId  直播间id
 * @returns 
 */

export const setAutoBind = (webcastId,status) =>put(`${config.cppm}monitor/v1/webcast/${webcastId}/auto/ref/setting/${status}`)